import { InternalAssessmentRowActions as RowActions } from "./InternalAssessmentRowActions.hooks";
import { LegalEntityAuditStatus } from "../../legalEntity/legalEntityAuditTab/LegalEntityAudit.types";
import DeleteInternalAssessmentDialog from "../deleteInternalAssessmentDialog/DeleteInternalAssessmentDialog";
import CloseInternalAssessmentDialog from "../closeInternalAssessmentDialog/CloseInternalAssessmentDialog";
import ReopenInternalAssessmentDialog from "../reopenInternalAssessmentDialog/ReopenInternalAssessmentDialog";
import ChangeAssigneeDialog from "../changeAssigneeDialog/ChangeAssigneeDialog";
import ChangeInternalAssessmentResponsibleDialog from "../changeInternalAssessmentResponsibleDialog/ChangeInternalAssessmentResponsibleDialog";
import SendInternalAssessmentReminderDialog from "../sendInternalAssessmentReminderDialog/SendInternalAssessmentReminderDialog";
import EvaluateInternalAssessmentDialog from "../evaluateInternalAssessmentDialog/EvaluateInternalAssessmentDialog";
import ToggleInternalAssessmentRemindersDialog from "../toggleInternalAssessmentRemindersDialog/ToggleInternalAssessmentRemindersDialog";

export interface IInternalAssessmentRowActionsProps {
    rowActions: RowActions;
}

function InternalAssessmentRowActions({ rowActions }: IInternalAssessmentRowActionsProps) {
    const { dialog, closeDialog, onDialogSaved, onAssessmentDeleted } = rowActions;

    if (!dialog) {
        return null;
    }

    switch (dialog.kind) {
        case "delete":
            return <DeleteInternalAssessmentDialog onDialogClose={closeDialog} selectedAssessment={dialog.row} onSuccessDelete={onAssessmentDeleted} />;
        case "close":
            return (
                <CloseInternalAssessmentDialog onDialogClose={closeDialog} onInternalAssessmentClosed={onDialogSaved} selectedInternalAssessment={dialog.row} />
            );
        case "reopen":
            return (
                <ReopenInternalAssessmentDialog
                    onDialogClose={closeDialog}
                    onInternalAssessmentReopened={onDialogSaved}
                    internalAssessmentId={dialog.row.id}
                    deadline={dialog.row.deadline}
                    name={dialog.row.name}
                    isSubmitted={dialog.row.status === LegalEntityAuditStatus.Submitted}
                />
            );
        case "assignee":
            return <ChangeAssigneeDialog internalAssessmentViewModel={dialog.row} onDialogClose={closeDialog} onChangedAssignee={onDialogSaved} />;
        case "responsible":
            return (
                <ChangeInternalAssessmentResponsibleDialog
                    responsible={dialog.row.responsible.id}
                    internalAssessmentId={dialog.row.id}
                    onDialogClose={closeDialog}
                    onChangedResponsible={onDialogSaved}
                />
            );
        case "reminder":
            return <SendInternalAssessmentReminderDialog onCloseDialog={closeDialog} onReminderSent={onDialogSaved} selectedInternalAssessment={dialog.row} />;
        case "evaluate":
            return <EvaluateInternalAssessmentDialog onEvaluated={onDialogSaved} onDialogClose={closeDialog} selectedInternalAssessment={dialog.row} />;
        case "toggleReminders":
            return (
                <ToggleInternalAssessmentRemindersDialog
                    onDialogClose={closeDialog}
                    onInternalAssessmentPaused={onDialogSaved}
                    internalAssessment={dialog.row}
                />
            );
    }
}

export default InternalAssessmentRowActions;
